var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    transform: "translate(21.1429 28.1905)",
    d: "M19.380951 1.3214285C19.380951 0.58913755 19.970089 0 20.702381 0L30.392857 0C31.125147 0 31.714285 0.58913755 31.714285 1.3214285L31.714285 11.011905C31.714285 11.744196 31.125147 12.333333 30.392857 12.333333C29.660566 12.333333 29.071428 11.744196 29.071428 11.011905L29.071428 4.5093746L18.505507 14.981697C18.0375 15.543303 17.200594 15.543303 16.683035 14.981697L10.571428 8.9141369L2.2557881 17.184078C1.7398807 17.745684 0.90297604 17.745684 0.38701314 17.184078C-0.12900439 16.716072 -0.12900439 15.879167 0.38701314 15.361608L9.635416 6.1116071C10.152975 5.5995536 10.989881 5.5995536 11.457887 6.1116071L17.619047 12.228721L27.20491 2.6428571L20.702381 2.6428571C19.970089 2.6428571 19.380951 2.0537195 19.380951 1.3214285Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.23f1f9444f4a6e2c7d37d21aa6e34889.svg";
export { ForwardRef as ReactComponent };